import cz from '../csCZ/search';

const en: typeof cz = {
	title: 'Census records and indexes',
	title_advanced: 'Advanced search',
	title_results: 'Search results',
	year_of_census: 'Census year',
	street: 'Street',
	house_number: 'House number',
	first_name: 'First name',
	surname: 'Surname',
	inventary_number: 'Inventory number',
	name_register: 'Name register',
	volume: 'Volume',
	page: 'Page',
	show_people: 'Display persons from houses',
	perform_search: 'Search',
	year: 'Year',
	street_name: 'Street name',
	persons_by_registry: 'Persons according the register',
	operates_image: 'Picture of records',
	page_text: 'Page of name register (inv. n., volume, page, line)',
	no_results: 'No results found',
};

export default en;
